import React from 'react'

import { Body2, Bold, Heading2, Link, Space } from '@gousto-internal/citrus-react'

import { LandingPageButton, TwoColumnLayout } from '../../../../components'
import fryingpan from '../assets/fryingpan.jpg'
import { EXPLORE_GOUSTO } from './config'

import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import {
  MealPlanningSections,
  TargetUri,
  TrackingActions,
  simpleTrackRedirect,
} from '../../../../types/tracking'

export function ExploreGoustoSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <TwoColumnLayout image={{ src: fryingpan, alt: EXPLORE_GOUSTO.altText }}>
      <Heading2>{EXPLORE_GOUSTO.headingLine1}</Heading2>
      <Space size={3} />
      <Body2 size={4}>
        Our menu changes weekly, keeping your meal plan options fresh and exciting. With over 175
        recipes to choose from each week, including{' '}
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={MealPlanningSections.EXPLORE_GOUSTO}
          target={TargetUri.TEN_MINUTE_MEALS}
          action={TrackingActions.SPEEDY_10_MIN_MEALS_HELP}
          asLink
        >
          10 Minute Meals,
        </LandingPageButton>{' '}
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={MealPlanningSections.EXPLORE_GOUSTO}
          target={TargetUri.CALORIE_CONTROLLED}
          action={TrackingActions.CALORIE_CONTROLLED_HELP}
          asLink
        >
          healthy options
        </LandingPageButton>{' '}
        and adventurous global cuisines,<Bold> your Gousto meal plan fits around your needs.</Bold>
      </Body2>
      <Space size={6} />
      <Body2 size={4}>
        Whether you’re cooking for one or feeding a hungry bunch, we&apos;ve got the kit for you.
        And if you need to change your delivery day, skip a week or pause, that&apos;s easy too. See{' '}
        <Link
          href={TargetUri.HOW_GOUSTO_FOOD_BOXES_WORK}
          onClick={() =>
            simpleTrackRedirect(
              TrackingActions.HOW_GOUSTO_WORKS,
              MealPlanningSections.EXPLORE_GOUSTO,
              TargetUri.HOW_GOUSTO_FOOD_BOXES_WORK,
            )
          }
        >
          how a Gousto subscription works
        </Link>{' '}
        to learn more.
      </Body2>
      <Space size={6} />
    </TwoColumnLayout>
  )
}
